import * as React from 'react';
import { FC } from 'react';
import {
    Edit,
    EditProps,
    useRecordContext,
    useTranslate,
    useRedirect,
} from 'react-admin';
import FinancingsCommonEdit from './TransactionCommonEdit';
import {
    makeStyles,
    createStyles,
    Theme,
    CardContent,
    Card,
    CardActions,
    Button,
    Box,
    Grid,
    useMediaQuery,
} from '@material-ui/core';
import Aside from '../components/commonAside';
import { useHistory } from 'react-router';
import { ArrowBack } from '@material-ui/icons';
import ConciliationTransactionsTable from './ConciliationTransactions';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        card: {
            width: '100%'
        },
    })
)

const FinancingTitle = ({ record }: any) => {
    const translate = useTranslate()
    return <span>{translate('resources.Financing.title', { reference: record.id })}</span>;
};

const TransactionAside = (props: any) => {
    const translate = useTranslate()
    const record = useRecordContext(props) as any;
    const redirect = useRedirect();

    return <>
        <Aside {...props} />
        <Button
            // endIcon={<OpenInNew />}
            color="primary"
            onClick={(e) => {
                redirect('edit', '/Merchant', record?.merchant_id)
            }}
        >
            {translate('resources.Transaction.links.merchant')}
        </Button>
        <Button
            // endIcon={<OpenInNew />}
            color="primary"
            onClick={(e) => {
                redirect('edit', '/Financing', record?.financing_id)
            }}
        >
            {translate('resources.Transaction.links.financing')}
        </Button>
    </>
}


const EditLayout = (props: any) => {
    const classes = useStyles()
    const history = useHistory()

    const isSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    return <>
        <Card className={classes.root}>
            <CardActions>
                <Button
                    variant="text"
                    color="primary"
                    startIcon={<ArrowBack />}
                    onClick={() => history.goBack()}
                >Atrás
                </Button>
            </CardActions>
            <CardContent>
                <Grid container className={classes.root} spacing={2}>
                    {isSmall && <Grid item xs={12} sm={12}>
                        <Aside />
                    </Grid>
                    }
                    <Grid item xs={12} sm={12}>
                        <FinancingsCommonEdit {...props} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
        <Box m="1em 0 0 0">
            <Card className={classes.root}>
                <CardContent>
                    <ConciliationTransactionsTable {...props} />
                </CardContent>
            </Card>
        </Box>
    </>
}

const MerchantEdit: FC<EditProps> = props => {
    const classes = useStyles()

    const isSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    return (
        <Edit
            component={Box}
            title={<FinancingTitle />}
            aside={!isSmall ?
                <Box m="0 0 1em 1em">
                    <Card className={classes.card}>
                        <CardContent>
                            <TransactionAside {...props} />
                        </CardContent>
                    </Card>
                </Box> : <></>}
            {...props}
        >
            <EditLayout />
        </Edit >
    )
}
export default MerchantEdit;
